 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		29: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"0":"component-library-content-TheWestLive-TheWestLivePlayerPage-TheWestLivePlayerPage","1":"masthead-albany-advertiser","2":"masthead-broome-advertiser","3":"masthead-busselton-dunsborough-times","4":"masthead-countryman","5":"masthead-geraldton-guardian","6":"masthead-great-southern-herald","7":"masthead-midwest-times","8":"masthead-sound-telegraph","9":"masthead-south-western-times","10":"vendors~component-library-content-TheWestLive-TheWestLivePlayerPage-TheWestLivePlayerPage","11":"component-library-advertising-SponsoredTopic-BullsNBearsLogo","12":"component-library-advertising-SponsoredTopic-HerdNTTerraceLogo","13":"component-library-banners-SocialBanner-SocialBanner","14":"component-library-cards-PNBreakingNews-PNBreakingNews","15":"component-library-contact-us-PNContactUsContent-PNContactUsContent","16":"component-library-content-AflTeamFlags-AflTeamFlags","17":"component-library-content-Horoscope-Horoscope","18":"component-library-content-TheWestLive-TheWestLivePromoBanner-TheWestLivePromoBanner","19":"component-library-content-Video-providers-SwmPlayerProvider","20":"component-library-publication-ArticleVideo-ArticleVideo-amp","21":"component-library-publication-ArticleVideo-ArticleVideo-web","22":"component-library-publication-Embed-Embed-amp","23":"component-library-publication-Embed-Embed-preview","24":"component-library-publication-Embed-Embed-rss","25":"component-library-publication-Embed-Embed-web","26":"component-library-publication-Embed-web-Shortstack","27":"component-library-templates-BaseTheWest-BaseTheWest-amp","30":"my-home","31":"vendors~component-library-content-Video-providers-SwmPlayerProvider","32":"vendors~component-library-publication-ArticleVideo-ArticleVideo-amp","33":"vendors~component-library-publication-Embed-web-Shortstack"}[chunkId]||chunkId) + "_" + {"0":"828c051a3b637a9ab6a7","1":"146ee901c7a5e96f4de5","2":"db9c972758e6b6f519ef","3":"d574a44edecf564ceb60","4":"9dff1404747ef2aa3593","5":"e1fe6b4c74efbca8a070","6":"57cac4a2115e2347c644","7":"1f13b09a0e9efd0eee43","8":"44c0e25545191c568a19","9":"dfcc9c1564cf79450ba5","10":"6ac6d3c227278f6550b0","11":"3211fe41a89877360fd3","12":"a9f512107af8e517f473","13":"f35617a2d3f3ca45bc80","14":"6e9c896c60e64f6e90af","15":"1add59aa410bb964c9c8","16":"bb5446370fb0522770c9","17":"58a2cfe6dd177e428a06","18":"48600d7a75f1dcf71604","19":"00ead85fe043329b5bcb","20":"3d121959cb5bb26d77e8","21":"0bbf58c9d9411fc882fb","22":"8943522843466bdc699d","23":"83ef17f8f698a106d467","24":"f5a6fd1ec79cefb15217","25":"f6b85617535d2c5352f3","26":"ea52770f42a602720b3f","27":"c9fd0a8511514b0d4b53","30":"0887554b70c46ed3f1f5","31":"b5bcd90de710f0819627","32":"15522cfbfe4fc47c6441","33":"7e2a155f499107207884"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
